export const version = 'v2.67.0-12-g78cf49f2';
